import { Reducer } from "../../lib/redux";
import { IDailyOdometer } from "../../model/DutyStatusLogs";
import { extend } from "../../utils/vanilla";
import { DailyOdometerActions } from "./actions";
import { DailyOdometerActionTypes } from "./types";

export let defaultDailyOdometer: IIdDictionary<IDailyOdometer> = {};

export let dailyOdometer: Reducer<IIdDictionary<IDailyOdometer>, DailyOdometerActions> = (state = defaultDailyOdometer, action) => {
    switch (action.type) {
        case DailyOdometerActionTypes.SET_DAILYODOMETER: {
            const userId = action.payload.userId;
            const odometer = action.payload.dailyOdometer ? extend(true, {}, action.payload.dailyOdometer) : {};
            if (userId) {
                return {
                    ...state,
                    [userId]: odometer
                };
            }
            return state;
        }
        case DailyOdometerActionTypes.CLEAR_DAILYODOMETER: {
            const userId = action.payload.userId;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return defaultDailyOdometer;
        }
        default:
            return state;
    }
};
